import { render, staticRenderFns } from "./NetworkTable.vue?vue&type=template&id=0a48f0cd&scoped=true&"
import script from "./NetworkTable.vue?vue&type=script&lang=js&"
export * from "./NetworkTable.vue?vue&type=script&lang=js&"
import style0 from "./NetworkTable.vue?vue&type=style&index=0&id=0a48f0cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48f0cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
